module.exports = __webpack_public_path__ + "static/media/opakowania_01_B.7fd00002.png";